import { Box } from "@mui/material";
import { lighten, useTheme } from "@mui/material/styles";

import { getShadedCommonground } from "../../utils/helpers";

const WidgetContent = props => {
  const theme = useTheme();

  const { noMargins = false, footer = false } = props;

  return (
    <Box
      sx={
        noMargins
          ? {
              margin: 0,
              padding: 0,
              display: "flex",
              flexDirection: "column",
              height: footer ? "calc(100% - 100px)" : "calc(100% - 64px)",
              maxHeight: footer ? "calc(100% - 100px)" : "calc(100% - 64px)",
              overflowY: "hidden",
            }
          : {
              marginLeft: theme.spacing(2),
              marginRight: theme.spacing(1),
              paddingRight: theme.spacing(1),
              marginTop: theme.spacing(1),
              marginBottom: theme.spacing(1),
              display: "flex",
              flexDirection: "column",
              height: footer ? "calc(100% - 100px)" : "calc(100% - 64px)",
              maxHeight: footer ? "calc(100% - 100px)" : "calc(100% - 64px)",

              overflowY: "auto",
              "&::-webkit-scrollbar": {
                width: theme.spacing(2),
                borderRadius: theme.spacing(1),
              },
              "&:hover::-webkit-scrollbar": {
                width: theme.spacing(2),
              },
              "&::-webkit-scrollbar-track": {
                borderRadius: theme.spacing(1),
                backgroundColor: getShadedCommonground(theme, 0.4),
                backgroundClip: "content-box",
              },
              "&::-webkit-scrollbar-thumb": {
                opacity: "0.5",
                borderRadius: theme.spacing(1),
                backgroundColor: theme.palette.secondary.main,
              },
              "&:hover::-webkit-scrollbar-thumb": {
                backgroundColor: lighten(theme.palette.secondary.main, 0.2),
              },
              overflowX: "hidden",
            }
      }
    >
      {props.children}
    </Box>
  );
};

export default WidgetContent;
